import { BusinessObjectItem } from '@lg/shared'
import { BoReference } from '@lg/shared'
import {
	Process,
	ProcessUserTask,
	ProcessUserTaskAssignment,
	ProcessUserTaskExtensionElement,
	ProcessUserTaskOutputHandler,
} from '@lg/shared'
import { ProcessEditorService } from '../process-editor/process-editor.service'
import { ScreenItemEditorHelper } from './screen-item-editor-helper'
import { inject, Injectable } from '@angular/core'
type UserTask = any

@Injectable({
	providedIn: 'root',
})
export class UserTaskEditorHelper extends ScreenItemEditorHelper<
	Process,
	UserTask
> {
	private processEditorService = inject(ProcessEditorService)

	protected getInputAssignmentMap(item: UserTask): Map<string, string> {
		const { moddle, modeling } = this.processEditorService

		return {
			set(key: string, value: any) {
				const extensions =
					item.businessObject.extensionElements ??
					moddle.create('bpmn:ExtensionElements')
				let assignmentObj: ProcessUserTaskAssignment = extensions
					.get('values')
					.find(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskAssignment' && v.variableName == key,
					)
				if (assignmentObj) {
					assignmentObj.expression = value
				} else {
					assignmentObj = moddle.create('lowgile:UserTaskAssignment', {
						variableName: key,
						expression: value,
					} as ProcessUserTaskExtensionElement)
					extensions.values.push(assignmentObj)
				}
				modeling.updateProperties(item, { extensionElements: extensions })
				return this
			},
			get(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskAssignment = extensions?.values?.find(
					(v: ProcessUserTaskExtensionElement) =>
						v.$type == 'lowgile:UserTaskAssignment' && v.variableName == key,
				)
				return assignmentObj?.expression
			},
			has(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskAssignment = extensions?.values?.find(
					(v: ProcessUserTaskExtensionElement) =>
						v.$type == 'lowgile:UserTaskAssignment' && v.variableName == key,
				)
				return !!assignmentObj
			},
			delete(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskAssignment = extensions?.values?.find(
					(v: ProcessUserTaskExtensionElement) =>
						v.$type == 'lowgile:UserTaskAssignment' && v.variableName == key,
				)
				if (assignmentObj) {
					extensions.values = extensions.values.filter(
						(v) => v != assignmentObj,
					)
					modeling.updateProperties(item, { extensionElements: extensions })
				}
				return this
			},
			entries() {
				const extensions = item.businessObject.extensionElements
				let assignmentObjs: ProcessUserTaskAssignment[] =
					extensions?.values?.filter(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskAssignment',
					)
				return (
					assignmentObjs?.map((a: any) => [a.variableName, a.expression]) ?? []
				)
			},
		} as unknown as Map<string, string>
	}

	protected getOutputAssignmentMap(item: UserTask): Map<string, string> {
		const { moddle, modeling } = this.processEditorService

		return {
			set(key: string, value: any) {
				const extensions =
					item.businessObject.extensionElements ??
					moddle.create('bpmn:ExtensionElements')
				let assignmentObj: ProcessUserTaskOutputHandler = extensions
					.get('values')
					.find(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskOutputHandler' && v.outputName == key,
					)
				if (assignmentObj) {
					assignmentObj.code = value
				} else {
					assignmentObj = moddle.create('lowgile:UserTaskOutputHandler', {
						outputName: key,
						code: value,
					} as ProcessUserTaskOutputHandler)
					extensions.values.push(assignmentObj)
				}
				modeling.updateProperties(item, { extensionElements: extensions })
				return this
			},
			get(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskOutputHandler =
					extensions?.values?.find(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskOutputHandler' && v.outputName == key,
					)
				return assignmentObj?.code
			},
			has(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskOutputHandler =
					extensions?.values?.find(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskOutputHandler' && v.outputName == key,
					)
				return !!assignmentObj
			},
			delete(key: string) {
				const extensions = item.businessObject.extensionElements
				let assignmentObj: ProcessUserTaskOutputHandler =
					extensions?.values?.find(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskOutputHandler' && v.outputName == key,
					)
				if (assignmentObj) {
					extensions.values = extensions.values.filter(
						(v) => v != assignmentObj,
					)
					modeling.updateProperties(item, { extensionElements: extensions })
				}
				return this
			},
			entries() {
				const extensions = item.businessObject.extensionElements
				let assignmentObjs: ProcessUserTaskOutputHandler[] =
					extensions?.values?.filter(
						(v: ProcessUserTaskExtensionElement) =>
							v.$type == 'lowgile:UserTaskOutputHandler',
					)
				return (
					assignmentObjs?.map((a: any) => [a.outputName, a.expression]) ?? []
				)
			},
		} as unknown as Map<string, string>
	}

	protected getScreenRef(item: UserTask): BoReference<'Screen'> {
		return BoReference.fromQualifiedName(
			(item as ProcessUserTask).$attrs['lowgile:screenRef'],
			'Screen',
		)
	}

	protected async getRefsToReferencedBos(
		item: BusinessObjectItem,
	): Promise<BoReference[]> {
		// debugger
		return [
			BoReference.fromQualifiedName(item.businessObject.screenRef, 'Screen'),
		]
	}
}
